// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowThin_arrow__4M3Je"};